module.exports = __webpack_public_path__ + "static/media/IMG_1532.9375ee23.JPG";